import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("선물하기")
const _hoisted_3 = {
  id: "content",
  class: "content"
}
const _hoisted_4 = { class: "product_lst_area type_best divider" }
const _hoisted_5 = /*#__PURE__*/_createVNode("h2", { class: "lst_tit" }, "베스트상품", -1)
const _hoisted_6 = {
  key: 2,
  class: "btn_area"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_component = _resolveComponent("header-component")
  const _component_navigator_component = _resolveComponent("navigator-component")
  const _component_content_placeholder_component = _resolveComponent("content-placeholder-component")
  const _component_promotion_banner_component = _resolveComponent("promotion-banner-component")
  const _component_theme_banner_component = _resolveComponent("theme-banner-component")
  const _component_product_list_component = _resolveComponent("product-list-component")
  const _component_to_top_component = _resolveComponent("to-top-component")

  return (_openBlock(), _createBlock("div", {
    id: "wrap",
    class: ["wrap", {app_view: _ctx.isApp}]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_header_component, null, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_navigator_component, { "navigator-code": "home" }),
      _withDirectives(_createVNode(_component_content_placeholder_component, null, null, 512), [
        [_vShow, !_ctx.isLoadingCompleted]
      ]),
      (_ctx.promotionBannerDataReceiverd)
        ? (_openBlock(), _createBlock(_component_promotion_banner_component, {
            key: 0,
            promotionBanners: _ctx.promotionBanners,
            onLoadPromotionBannerImage: _ctx.loadPromotionBannerImage
          }, null, 8, ["promotionBanners", "onLoadPromotionBannerImage"]))
        : _createCommentVNode("", true),
      (_ctx.themeBannerDataReceiverd)
        ? (_openBlock(), _createBlock(_component_theme_banner_component, {
            key: 1,
            themeBanners: _ctx.themeBanners,
            onLoadThemeBannerImage: _ctx.loadThemeBannerImage
          }, null, 8, ["themeBanners", "onLoadThemeBannerImage"]))
        : _createCommentVNode("", true),
      _withDirectives(_createVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_product_list_component, {
          products: _ctx.products,
          onLoadProductImage: _ctx.loadProductImage
        }, null, 8, ["products", "onLoadProductImage"])
      ], 512), [
        [_vShow, _ctx.isLoadingCompleted]
      ]),
      (_ctx.isLoadingCompleted)
        ? (_openBlock(), _createBlock("div", _hoisted_6, [
            _createVNode("button", {
              class: "btn btn_default",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.moveProductsPage && _ctx.moveProductsPage(...args)))
            }, " 전체 상품 보기 ")
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_to_top_component)
  ], 2))
}